module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showTerms,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('terms-modal', {
    attrs: {
      "selected_country": _vm.newAsso.country
    }
  })], 1)], 1)]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Associations')))]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#all-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#add-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('Add')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#update-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('Update')))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrapper associations-tabs"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "all-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('All Associations')))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.$store.getters.getAssociations.length))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$store.getters.getAssociations), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "association-list-item"
    }, [_c('span', {
      staticClass: "asso-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "add-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Add New Association')))]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "id": "add-asso-form"
    }
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('First name'),
      "id": "fname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.first_name),
      expression: "newAsso.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "first_name",
      "aria-describedby": "fname-addon1",
      "type": "text",
      "placeholder": _vm.$t('First name')
    },
    domProps: {
      "value": _vm.newAsso.first_name,
      "value": (_vm.newAsso.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.first_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Last name'),
      "id": "lname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.last_name),
      expression: "newAsso.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "last_name",
      "aria-describedby": "lname-addon1",
      "type": "text",
      "placeholder": _vm.$t('Last name')
    },
    domProps: {
      "value": _vm.newAsso.last_name,
      "value": (_vm.newAsso.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Birthday'),
      "id": "birthday-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.birthday),
      expression: "newAsso.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthday",
      "aria-describedby": "birthday-addon1",
      "type": "date",
      "placeholder": _vm.$t('Birthday')
    },
    domProps: {
      "value": _vm.newAsso.birthday,
      "value": (_vm.newAsso.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.birthday = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Nationality'),
      "id": "nationality-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.nationality),
      expression: "newAsso.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.nationality = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(ctr) {
    return _c('option', {
      attrs: {
        "disabled": ctr.code == '_'
      },
      domProps: {
        "selected": ctr.code == 'ES',
        "value": ctr.code
      },
      on: {
        "changed": function($event) {
          _vm.newAsso.nationality = ctr.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(ctr.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country of residence'),
      "id": "country_of_residence-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.country_of_residence),
      expression: "newAsso.country_of_residence"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "country_of_residence-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.country_of_residence = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signin.country_of_residence = country.code
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(country.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Association name'),
      "id": "name-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.name),
      expression: "newAsso.name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "name",
      "aria-describedby": "name-addon1",
      "type": "text",
      "placeholder": _vm.$t('Association name')
    },
    domProps: {
      "value": _vm.newAsso.name,
      "value": (_vm.newAsso.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('description'),
      "id": "description-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.description),
      expression: "newAsso.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "description",
      "aria-describedby": "description-addon1",
      "type": "text",
      "placeholder": _vm.$t('description')
    },
    domProps: {
      "value": _vm.newAsso.description,
      "value": (_vm.newAsso.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Logo URL'),
      "id": "logo_url-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.logo_url),
      expression: "newAsso.logo_url"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "logo_url",
      "aria-describedby": "logo_url-addon1",
      "type": "text",
      "placeholder": _vm.$t('Logo URL')
    },
    domProps: {
      "value": _vm.newAsso.logo_url,
      "value": (_vm.newAsso.logo_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.logo_url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Twitter Username'),
      "id": "twitter_username-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.twitter_username),
      expression: "newAsso.twitter_username"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "twitter_username",
      "aria-describedby": "twitter_username-addon1",
      "type": "text",
      "placeholder": _vm.$t('Twitter Username')
    },
    domProps: {
      "value": _vm.newAsso.twitter_username,
      "value": (_vm.newAsso.twitter_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.twitter_username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('IBAN'),
      "id": "iban-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.bank_account_iban),
      expression: "newAsso.bank_account_iban"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bank_account_iban",
      "aria-describedby": "iban-addon1",
      "type": "text",
      "placeholder": _vm.$t('IBAN')
    },
    domProps: {
      "value": _vm.newAsso.bank_account_iban,
      "value": (_vm.newAsso.bank_account_iban)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.bank_account_iban = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('BIC'),
      "id": "bic-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.bank_account_bic),
      expression: "newAsso.bank_account_bic"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bank_account_bic",
      "aria-describedby": "bic-addon1",
      "type": "text",
      "placeholder": _vm.$t('BIC')
    },
    domProps: {
      "value": _vm.newAsso.bank_account_bic,
      "value": (_vm.newAsso.bank_account_bic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.bank_account_bic = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.country),
      expression: "newAsso.country"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "country-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.newAsso.country = country.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(country.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('City'),
      "id": "city-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.city),
      expression: "newAsso.city"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "city",
      "aria-describedby": "city-addon1",
      "type": "text",
      "placeholder": _vm.$t('City')
    },
    domProps: {
      "value": _vm.newAsso.city,
      "value": (_vm.newAsso.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('address'),
      "id": "address-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.address),
      expression: "newAsso.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "aria-describedby": "address-addon1",
      "type": "text",
      "placeholder": _vm.$t('address')
    },
    domProps: {
      "value": _vm.newAsso.address,
      "value": (_vm.newAsso.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Email'),
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.mail),
      expression: "newAsso.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.newAsso.email,
      "value": (_vm.newAsso.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.mail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Password'),
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.password),
      expression: "newAsso.password"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.newAsso.password,
      "value": (_vm.newAsso.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Terms and conditions'),
      "id": "terms-addon1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptTerms),
      expression: "acceptTerms"
    }],
    attrs: {
      "required": "",
      "name": "accept_terms",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.acceptTerms,
      "value": _vm.acceptTerms,
      "checked": Array.isArray(_vm.acceptTerms) ? _vm._i(_vm.acceptTerms, _vm.acceptTerms) > -1 : (_vm.acceptTerms)
    },
    on: {
      "click": _vm.toggleTermsModal,
      "__c": function($event) {
        var $$a = _vm.acceptTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.acceptTerms,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.acceptTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.acceptTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptTerms = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "for": "accept_terms",
      "aria-describedby": "terms-addon1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms and conditions')))])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block newAsso-btn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.acceptTerms
    },
    on: {
      "click": _vm.registerAssoUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Register')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "update-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Update Associations.')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-xs edit-asso-btn pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb3cfeb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 319
// module chunks = 1